<template>
  <div>
    <div key="timer" v-if="timePassed !== 40" class="base-timer">
      <svg
        class="base-timer__svg"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g class="base-timer__circle">
          <circle class="base-timer__path-elapsed" cx="50" cy="50" r="45" />
          <path
            :stroke-dasharray="circleDasharray"
            class="base-timer__path-remaining"
            :class="remainingPathColor"
            d="
            M 50, 50
            m -45, 0
            a 45,45 0 1,0 90,0
            a 45,45 0 1,0 -90,0
          "
          />
        </g>
      </svg>
      <span class="base-timer__label text-white">{{ formattedTimeLeft }}</span>
    </div>
  </div>
</template>

<script>
const FULL_DASH_ARRAY = 283;
const WARNING_THRESHOLD = 20;
const ALERT_THRESHOLD = 10;

const COLOR_CODES = {
  alert: {
    color: "green",
    threshold: ALERT_THRESHOLD,
  },

  warning: {
    color: "orange",
    threshold: WARNING_THRESHOLD,
  },
  info: {
    color: "red",
  },
};

const TIME_LIMIT = 60;

// import EventBus from "@/utils/event_bus";

export default {
  data() {
    return {
      status: "",
      timePassed: 0,
      timerInterval: null,
    };
  },

  computed: {
    circleDasharray() {
      return `${(this.timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`;
    },

    formattedTimeLeft() {
      const timeLeft = this.timeLeft;
      // const minutes = Math.floor(timeLeft / 60);
      let seconds = timeLeft % 60;

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      return `${seconds}`;
    },

    timeLeft() {
      return TIME_LIMIT - this.timePassed;
    },

    timeFraction() {
      const rawTimeFraction = this.timeLeft / TIME_LIMIT;
      return rawTimeFraction - (1 / TIME_LIMIT) * (1 - rawTimeFraction);
    },

    remainingPathColor() {
      const { alert, warning, info } = COLOR_CODES;

      if (this.timeLeft <= alert.threshold) {
        return alert.color;
      } else if (this.timeLeft <= warning.threshold) {
        return warning.color;
      } else {
        return info.color;
      }
    },
  },

  watch: {
    timeLeft(newValue) {
      if (newValue === 0) {
        this.onTimesUp();
        clearInterval(this.timerInterval);
      }
    },
  },

  // beforeCreate() {
  //   EventBus.$on("TIMER_REVIEW", (payload) => this.startTimer(payload));

  //   console.log("CHEGOU");
  // },

  mounted() {
    this.startTimer();
  },

  methods: {
    onTimesUp() {
      clearInterval(this.timerInterval);
    },

    startTimer(payload) {
      this.status = payload;
      this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
      this.timePassed = 0;

      // clearInterval(this.timerInterval);
    },
  },

  // unmounted() {
  //   clearInterval(this.timerInterval);
  //   EventBus.$off("TIMER_REVIEW", (payload) => this.startTimer(payload));
  // },
};
</script>

<style scoped lang="scss">
.base-timer {
  // left: 50px;
  // top: 12px;
  position: relative;
  width: 40px;
  height: 40px;
  &__svg {
    transform: scaleX(-1);
  }

  &__circle {
    fill: none;
    stroke: none;
  }

  &__path-elapsed {
    stroke-width: 8px;
    stroke: #171e27;
  }

  &__path-remaining {
    stroke-width: 8px;
    stroke-linecap: round;
    transform: rotate(90deg);
    transform-origin: center;
    transition: 1s linear all;
    fill-rule: nonzero;
    stroke: currentColor;

    &.green {
      color: #19d684;
    }

    &.orange {
      color: #f9cb07;
    }

    &.red {
      color: #f56565;
    }
  }

  &__label {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
  }
}

// @media only screen and (max-width: 480px) {
//   .base-timer {
//     left: 28px;
//   }
// }
</style>
